import { useState } from "react";
import { enqueueSnackbar } from "notistack";
import { useSession } from "users/__session/session-context";
import { CanceledError } from "axios";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material";
import PendingUserEntityMemberInvitationsTable from "legal-entities/invitations/member-invitations/email-based/pending/_views/pending-user-entity-member-invitations-table";
import PendingUserEntityMemberInvitation from "legal-entities/invitations/member-invitations/email-based/pending/pending-user-entity-member-invitation";
import SuperUserAPIService from "users/super-users/_api/super-user-api-service";

const StyledInvitationsContainer = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  position: "relative",
  overflowY: "auto", 
  height: "100%",
  width: "100%"
}));

export default function ActiveUserInvitationsPage() {
  const [invitations, setInvitations] = useState<PendingUserEntityMemberInvitation[]>([]);
  const session = useSession();

  async function getActiveInvitations() {
    if (invitations.length > 0) return; // Prevent unnecessary API calls if invitations are already loaded
    try {
      const superUserAPIService = new SuperUserAPIService(session);
      const returnedInvitations =
        await superUserAPIService.getActiveUserInvitations();
      setInvitations(returnedInvitations);
    } catch (error) {
      if (error instanceof CanceledError) return;
      console.error(error);
      enqueueSnackbar("Failed to get open invitations", { variant: "error" });
    }
  }
  
  void getActiveInvitations();

  return (
    <StyledInvitationsContainer>
      <PendingUserEntityMemberInvitationsTable
        invitations={invitations}
      />
    </StyledInvitationsContainer>
  );
}
